const rts = {
  handleSet_appForms: 'handleSet_appForms',
}

export const appFormsReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleSet_appForms:
      return {
        ...state,
        appForms: action.appForms
      }

    default:
      return { ...state }
  }
}

export const appFormsInitialState = (initState) => {
  return { ...initState }
};

export const appFormsHandlers = (dispatch) => {
  return {
    handleSet_appForms: (appForms) => { dispatch({ type: rts.handleSet_appForms, dispatch, appForms }) },
  }
} 